export default __webpack_public_path__ + "static/process-meeting-71bf46416557dbb4d80d0fcfc4fa9fda.jpg";